import { io } from "socket.io-client";

// ประกาศการเชื่อมต่อ socket ครั้งเดียว
const socket = io("https://api.pgzone88.com/");

export default socket;
